module.exports = __webpack_public_path__ + "static/media/unlocked.b14bffc1.png";